export const magdalenaFajkowska = {
    'meta': {
        'title': 'Psycholog, Psychoterapeuta Magdalena Fajkowska • COLLIGO',
        'description': 'Jestem psychologiem oraz psychoterapeutą, absolwentką psychologii. W pracy kieruję się etyką, stawiam na relację opartą na empatii i poczuciu bezpieczeństwa.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-psychoterapeuta-magdalena-fajkowska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/magdalena-fajkowska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog, Psychoterapeuta'
        }
    }
}